define("calendar/services/note", ["exports", "ember-concurrency/async-arrow-runtime", "@ember/service", "ember-concurrency", "later/utils/calendar/constants"], function (_exports, _asyncArrowRuntime, _service, _emberConcurrency, _constants) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  var _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _getUnixTimeStamp, _hasValidTimeStamp;
  0; //eaimeta@70e063a35619d71f0,"ember-concurrency/async-arrow-runtime",0,"@ember/service",0,"ember-concurrency",0,"later/utils/calendar/constants"eaimeta@70e063a35619d71f
  function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
  function _classPrivateMethodInitSpec(e, a) { _checkPrivateRedeclaration(e, a), a.add(e); }
  function _checkPrivateRedeclaration(e, t) { if (t.has(e)) throw new TypeError("Cannot initialize the same private elements twice on an object"); }
  function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
  function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
  function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
  function _classPrivateMethodGet(s, a, r) { return _assertClassBrand(a, s), r; }
  function _assertClassBrand(e, t, n) { if ("function" == typeof e ? e === t : e.has(t)) return arguments.length < 3 ? t : n; throw new TypeError("Private element is not present on this object"); }
  function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
  function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
  let NoteService = _exports.default = (_class = (_getUnixTimeStamp = /*#__PURE__*/new WeakSet(), _hasValidTimeStamp = /*#__PURE__*/new WeakSet(), class NoteService extends _service.default {
    constructor() {
      super(...arguments);
      _classPrivateMethodInitSpec(this, _hasValidTimeStamp);
      _classPrivateMethodInitSpec(this, _getUnixTimeStamp);
      _initializerDefineProperty(this, "alerts", _descriptor, this);
      _initializerDefineProperty(this, "dialogManager", _descriptor2, this);
      _initializerDefineProperty(this, "auth", _descriptor3, this);
      _initializerDefineProperty(this, "intl", _descriptor4, this);
      _initializerDefineProperty(this, "router", _descriptor5, this);
      _initializerDefineProperty(this, "store", _descriptor6, this);
      _defineProperty(this, "confirmClose", (0, _asyncArrowRuntime.buildTask)(() => ({
        context: this,
        generator: function* (hasChanges) {
          if (hasChanges) {
            const didConfirm = yield this.dialogManager.confirmation(this.intl.t('shared_phrases.close_warning'), {
              description: this.intl.t('shared_phrases.changes_not_saved'),
              confirmButton: this.intl.t('shared_words.leave')
            });
            if (!didConfirm) {
              return;
            }
          }
          this.transitionToCalendar();
        }
      }), null, "confirmClose", null));
      _defineProperty(this, "copyToClipboard", (0, _asyncArrowRuntime.buildTask)(() => ({
        context: this,
        generator: function* (noteContent) {
          try {
            yield navigator.clipboard.writeText(noteContent);
            this.alerts.success(this.intl.t('alerts.calendar_notes.copy_to_clipboard_success'));
          } catch (error) {
            this.alerts.warning(this.intl.t('alerts.generic_error_message'), {
              title: this.intl.t('alerts.calendar_notes.copy_to_clipboard_failure.title')
            });
          }
        }
      }), null, "copyToClipboard", null));
    }
    get currentGroup() {
      return this.auth.currentGroup;
    }
    update(id, timeStamp) {
      const unixTime = _classPrivateMethodGet(this, _getUnixTimeStamp, _getUnixTimeStamp2).call(this, timeStamp);
      if (_classPrivateMethodGet(this, _hasValidTimeStamp, _hasValidTimeStamp2).call(this, unixTime, id)) {
        this.store.findRecord('calendar-note', id).then(calendarNote => {
          calendarNote.set('scheduledTime', unixTime);
          calendarNote.save().catch(() => {
            calendarNote.rollbackAttributes();
            this.alerts.warning(this.intl.t('alerts.generic_error_message'), {
              title: this.intl.t('alerts.calendar_notes.problem_saving.title')
            });
          });
        });
      } else {
        this.alerts.alert(this.intl.t('alerts.calendar_notes.too_close_create.message'), {
          title: this.intl.t('alerts.calendar_notes.too_close_create.title')
        });
      }
    }
    create(timeStamp) {
      const unixTime = _classPrivateMethodGet(this, _getUnixTimeStamp, _getUnixTimeStamp2).call(this, timeStamp);
      if (_classPrivateMethodGet(this, _hasValidTimeStamp, _hasValidTimeStamp2).call(this, unixTime)) {
        this.router.transitionTo('cluster.schedule.calendar.notes.new', {
          queryParams: {
            scheduled_time: unixTime
          }
        });
      } else {
        this.alerts.alert(this.intl.t('alerts.calendar_notes.too_close_create.message'), {
          title: this.intl.t('alerts.calendar_notes.too_close_create.title')
        });
      }
    }
    shouldAllowSave(noteContent) {
      return this.getCharactersRemaining(noteContent) >= 0;
    }
    shouldShowCharacterLimit(noteContent) {
      return noteContent.length > _constants.NOTE_CHARACTER_LIMIT_THRESHOLD;
    }
    transitionToEdit(id) {
      this.router.transitionTo('cluster.schedule.calendar.notes.edit', id);
    }
    transitionToCalendar() {
      this.router.transitionTo('cluster.schedule.calendar');
    }
    getCharactersRemaining(noteContent) {
      return _constants.NOTE_MAXIMUM_CHARACTERS - noteContent.length;
    }
  }), (_descriptor = _applyDecoratedDescriptor(_class.prototype, "alerts", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "dialogManager", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "auth", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "intl", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "router", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, "store", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  })), _class);
  function _getUnixTimeStamp2(timeStamp) {
    return typeof timeStamp === 'number' ? timeStamp : timeStamp.unix() * 1000;
  }
  function _hasValidTimeStamp2(unixTime, excludedId) {
    if (!this.currentGroup.calendarNotes) {
      return true;
    }
    return this.currentGroup.calendarNotes.every(item => {
      if (item?.scheduledTime && item?.id !== excludedId) {
        // Notes fill 45 min block via css
        return Math.abs(item.scheduledTime - unixTime) > 2400;
      }
      return true;
    });
  }
});